import React from 'react';
import PropTypes from 'prop-types';

import FilterInput from "components/search_sidebar/filter_input";
import FilterSelect from "components/search_sidebar/filter_select";
import CityFilter from './city_filter';

export default class AddressFilterGroup extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.shape({
      buildingNumber: PropTypes.string,
      cities: PropTypes.array,
      currentCity: PropTypes.string,
      county: PropTypes.string,
      market: PropTypes.string,
      microMarket: PropTypes.string,
      state: PropTypes.string,
      street: PropTypes.string,
      subMarket: PropTypes.string,
      zip: PropTypes.string,
    }),
    filterLabelMappings: PropTypes.object.isRequired,
    marketTypeOptions: PropTypes.array.isRequired,
    microMarketTypeOptions: PropTypes.array.isRequired,
    subMarketTypeOptions: PropTypes.array.isRequired,
    onAddressFilterChange: PropTypes.func
  };

  handleChange = (e, name) => {
    this.props.onAddressFilterChange(e, name);
  }

  render() {
    return (
      <React.Fragment>
        {this.renderFilters()}
      </React.Fragment>
    );
  }

  renderFilters() {
    const {
      addressFilter: {
        buildingNumber,
        cities,
        currentCity,
        county,
        market,
        microMarket,
        state,
        street,
        subMarket,
        zip
      },
      filterLabelMappings,
      microMarketTypeOptions,
      marketTypeOptions,
      subMarketTypeOptions
    } = this.props;

    return (
      <React.Fragment>
        <div className="row left-buffer-sm right-buffer-sm">
          <FilterSelect
            defaultValue=""
            label={filterLabelMappings["market"]}
            name="market-type-filter"
            options={marketTypeOptions}
            placeholder="Select a Market"
            value={market}
            onChange={e => this.handleChange(e, "market")}
          />
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <FilterSelect
            defaultValue=""
            label={filterLabelMappings["subMarket"]}
            name="submarket-type-filter"
            options={subMarketTypeOptions}
            placeholder="Select a Submarket"
            value={subMarket}
            onChange={e => this.handleChange(e, "subMarket")}
          />
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <FilterSelect
            defaultValue=""
            label={filterLabelMappings["microMarket"]}
            name="micro-market-type-filter"
            options={microMarketTypeOptions}
            placeholder="Select a Micromarket"
            value={microMarket}
            onChange={e => this.handleChange(e, "microMarket")}
          />
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <FilterInput
            label={filterLabelMappings["buildingNumber"]}
            name="building-number-filter"
            value={buildingNumber}
            onChange={e => this.handleChange(e, "buildingNumber")}
          />
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <FilterInput
            label={filterLabelMappings["street"]}
            name="street-filter"
            value={street}
            onChange={e => this.handleChange(e, "street")}
          />
        </div>
        <div className="row left-buffer-sm right-buffer-sm form-group">
          <CityFilter
            cities={cities}
            currentCity={currentCity}
            onChange={this.handleChange}
          />
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <div className="col-md-4 pl-0">
            <FilterInput
              label={filterLabelMappings["state"]}
              name="state-filter"
              value={state}
              onChange={e => this.handleChange(e, "state")}
            />
          </div>
          <div className="col-md-8 pr-0">
            <FilterInput
              label={filterLabelMappings["zip"]}
              name="zip-filter"
              value={zip}
              onChange={e => this.handleChange(e, "zip")}
            />
          </div>
        </div>
        <div className="row left-buffer-sm right-buffer-sm">
          <FilterInput
            label={filterLabelMappings["county"]}
            name="county-filter"
            value={county}
            onChange={e => this.handleChange(e, "county")}
          />
        </div>
      </React.Fragment>
    );
  }
}
